import React from 'react';
import { GraduationCap } from 'lucide-react';

export default function LoadingScreen({ message = 'Loading...' }) {
  return (
    <div
      data-testid="loading-screen"
      className="fixed inset-0 bg-slate-50 flex flex-col items-center justify-center z-50"
    >
      <div className="flex flex-col items-center gap-4">
        <div className="w-16 h-16 bg-sky-500 rounded-2xl flex items-center justify-center shadow-lg animate-pulse">
          <GraduationCap className="w-9 h-9 text-white" />
        </div>
        <div className="flex gap-1.5 mt-2">
          {[0, 1, 2].map(i => (
            <div
              key={i}
              className="w-2 h-2 bg-sky-400 rounded-full animate-bounce"
              style={{ animationDelay: `${i * 0.15}s` }}
            />
          ))}
        </div>
        <p className="text-slate-500 text-sm">{message}</p>
      </div>
    </div>
  );
}
